"use strict";
'use client';

// TODO: Implement with Base UI Checkbox
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;
var _classVarianceAuthority = require("class-variance-authority");
var _react = require("react");
var _helpers = require("../../common/helpers");
var _Icon = require("../Icon");
var _classes = require("../../common/classes");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["label", "helperText", "className", "id", "required", "disabled", "error"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var formClasses = (0, _classVarianceAuthority.cva)(['flex', 'flex-row', 'items-start']);
var checkboxClasses = (0, _classVarianceAuthority.cva)(['appearance-none', 'cursor-pointer', 'border-2', 'rounded', 'h-5', 'w-5', 'transition', 'mt-0.5', 'mr-2', 'border-gray-200', 'enabled:hover:border-gray-700', 'accent-primary', 'text-primary', 'peer', 'focus:outline-0', 'focus:outline-offset-0', 'focus-visible:outline', 'focus-visible:outline-2', 'focus-visible:outline-offset-2', 'focus-visible:outline-offset-transparent', 'focus-visible:outline-primary', 'checked:border-transparent', 'enabled:hover:checked:border-transparent', 'checked:bg-current', 'shrink-0'], {
  variants: {
    disabled: {
      "true": ['cursor-not-allowed'],
      "false": []
    }
  }
});
var checkboxIconClasses = (0, _classVarianceAuthority.cva)(['absolute', 'hidden', 'peer-checked:block', 'w-3', 'h-3', 'mt-1.5', 'ml-1', 'pointer-events-none']);

/**
 * Checkbox - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/input-checkbox)
 */
var Checkbox = exports.Checkbox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var label = _ref.label,
    helperText = _ref.helperText,
    className = _ref.className,
    id = _ref.id,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    props = _objectWithoutProperties(_ref, _excluded);
  var generatedID = (0, _react.useId)();
  var inputID = id !== null && id !== void 0 ? id : generatedID;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _helpers.cn)(formClasses({
      className: className
    })),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      type: "checkbox",
      id: inputID,
      disabled: disabled,
      className: (0, _helpers.cn)(checkboxClasses({
        disabled: disabled
      }))
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      icon: "check",
      inverse: true,
      className: (0, _helpers.cn)(checkboxIconClasses())
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          htmlFor: inputID,
          className: (0, _helpers.cn)((0, _classes.clickableLabelClasses)({
            disabled: disabled
          })),
          children: label
        }), required && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          "aria-label": "required",
          className: (0, _helpers.cn)((0, _classes.requiredClasses)({
            disabled: disabled
          })),
          children: "*"
        })]
      }), helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _helpers.cn)((0, _classes.helperClasses)({
          disabled: disabled
        })),
        children: helperText
      }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _helpers.cn)((0, _classes.errorClasses)()),
        children: error
      })]
    })]
  });
});